var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.498 0C100.666 0 76.3919 7.36497 55.7495 21.1668C35.107 34.9665 19.0214 54.5821 9.52992 77.5289C0.038447 100.474 -2.43291 125.72 2.42931 150.07C7.28949 174.421 19.2671 196.783 36.8422 214.327C54.4173 231.871 76.8023 243.802 101.164 248.618C125.525 253.433 150.765 250.913 173.694 241.378C196.623 231.843 216.205 215.72 229.966 195.051C243.728 174.382 251.048 150.095 251 125.266C250.937 92.0216 237.687 60.1613 214.157 36.6793C190.629 13.1968 158.744 0.00746302 125.501 0.00746302L125.498 0ZM183.171 87.1685L122.63 172.786H122.627C121.588 174.281 119.912 175.21 118.09 175.293C116.412 175.32 114.802 174.622 113.673 173.381L72.9531 129.201C70.7125 126.76 70.8729 122.964 73.3113 120.724C75.7517 118.481 79.5477 118.641 81.7904 121.082L117.613 159.769L173.378 80.1223C175.319 77.4632 179.021 76.8281 181.737 78.6876C183.04 79.6017 183.925 80.999 184.194 82.569C184.463 84.1391 184.094 85.7509 183.17 87.0481L183.171 87.1685Z",
    fill: "#2A85FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.fb4b71c920de001b60452208221ffd2f.svg";
export { ForwardRef as ReactComponent };